export default "__VITE_ASSET__BR8RKWBz__"